import * as settings from './settings';
import axios from 'axios';
import {actions as system} from '../reducers/system';
import Message from '../enums/Message';
import _ from 'lodash';

// ENGINE
export const fetchJobs = () => {
	return axios.get(settings.getApi() + 'engine');
};

export const retryJobs = (jobid) => {
	return axios.post(settings.getApi() + 'retry/' + jobid, {}, requestDefaultConfig);
};

export const removeJob = (jobid) => {
    return axios.post(settings.getApi() + 'remove/' + jobid, {}, requestDefaultConfig);
};

export const removeAllJobs = () => {
    return axios.delete(settings.getApi() + 'removeall', requestDefaultConfig);
}

// PROJECTS
export const fetchProjects = () => {
	return axios.get(settings.getApi() + 'projects');
};

export const fetchProject = (name) => {
	return axios.get(settings.getApi() + 'projects/' + name);
};

export const createProject = (project) => {
	return axios.post(settings.getApi() + 'projects', {data: project}, requestDefaultConfig);
};

export const updateProject = (name, project) => {
	return axios.post(settings.getApi() + 'projects/' + name, {data: project}, requestDefaultConfig);
};

export const scanProject = (name, project) => {
	return axios.post(settings.getApi() + '');
};

export const deleteProject = (name) => {
	return axios.delete(settings.getApi() + 'projects/' + name, requestDefaultConfig);
};

export const importProject = (name) => {
	return axios.post(settings.getApi() + 'projects/' + name + '/import', null, requestDefaultConfig);
};

export const renderProject = (name) => {
	return axios.post(settings.getApi() + 'projects/' + name + '/render', null, requestDefaultConfig);
};

export const replaceDefaultLanguageInAllCollections = (projectName, oldLanguage, newLanguage) => {
	return axios.post(settings.getApi() + 'projects/' + projectName + '/replaceDefaultLanguageInAllCollections/' + oldLanguage + '/' + newLanguage, null, requestDefaultConfig);
};

//LANGUAGES
export const fetchLanguages = () => {
	return axios.get(settings.getApi() + 'languages');
};

export const createLanguage = (language) => {
	return axios.post(settings.getApi() + 'languages', {data: language}, requestDefaultConfig);
};

export const updateLanguage = (identifier, language) => {
	return axios.post(settings.getApi() + 'languages/' + identifier, {data: language}, requestDefaultConfig);
};

export const deleteLanguage = (identifier) => {
	return axios.delete(settings.getApi() + 'languages/' + identifier, requestDefaultConfig);
};

// LABEL_COLLECTIONS
export const fetchLabelCollections = (projectName) => {
	return axios.get(settings.getApi() + 'projects/' + projectName + '/labelCollections');
};

export const fetchLabelCollection = (projectName, identifier) => {
	return axios.get(settings.getApi() + 'projects/' + projectName + '/labelCollections/' + identifier);
};

export const createLabelCollection = (projectName, labelCollection) => {
	return axios.post(settings.getApi() + 'projects/' + projectName + '/labelCollections', {data: labelCollection}, requestDefaultConfig);
};

export const updateLabelCollection = (projectName, identifier, labelCollection) => {
	return axios.post(settings.getApi() + 'projects/' + projectName + '/labelCollections/' + identifier, {data: labelCollection}, requestDefaultConfig);
};

export const deleteLabelCollection = (projectName, identifier) => {
	return axios.delete(settings.getApi() + 'projects/' + projectName + '/labelCollections/' + identifier, requestDefaultConfig);
};

export const translationsForLanguage = (projectName, labelCollectionIdentifier, languageIdentifier) => {
	return axios.get(settings.getApi() + 'labelCollectionLanguages/' + projectName + '/' + labelCollectionIdentifier + '/' + languageIdentifier + '/translations');
};

export const lockLanguage = (projectName, labelCollectionIdentifier, languageIdentifier) => {
	return axios.post(settings.getApi() + 'labelCollectionLanguages/' + projectName + '/' + labelCollectionIdentifier + '/' + languageIdentifier + '/lock', null, requestDefaultConfig);
};

export const finishLanguage = (projectName, labelCollectionIdentifier, languageIdentifier) => {
	return axios.post(settings.getApi() + 'labelCollectionLanguages/' + projectName + '/' + labelCollectionIdentifier + '/' + languageIdentifier + '/finish', null,  requestDefaultConfig);
};

// LABELS
export const fetchLabels = (projectName, labelCollectionIdentifier) => {
	return axios.get(settings.getApi() + 'projects/' + projectName + '/labelCollections/' + labelCollectionIdentifier + '/labels');
};

export const fetchAllLabels = (projectName) => {
	return axios.get(settings.getApi() + 'projects/' + projectName + '/labels/');
};

export const fetchLabel = (projectName, labelCollectionIdentifier, labelName) => {
	return axios.get(settings.getApi() + 'projects/' + projectName + '/labelCollections/' + labelCollectionIdentifier + '/labels/' + labelName);
};

export const createLabel = (projectName, labelCollectionIdentifier, label) => {
	return axios.post(settings.getApi() + 'projects/' + projectName + '/labelCollections/' + labelCollectionIdentifier + '/labels', {data: label}, requestDefaultConfig);
};

export const updateLabel = (projectName, labelCollectionIdentifier, labelName, label) => {
	return axios.post(settings.getApi() + 'projects/' + projectName + '/labelCollections/' + labelCollectionIdentifier + '/labels/' + labelName, {data: label}, requestDefaultConfig);
};

export const updateNoValueLabel = (projectName, labelCollectionIdentifier, labelName, valueState) => {
	return axios.post(settings.getApi() + 'projects/' + projectName + '/labelCollections/' + labelCollectionIdentifier + '/labels/' + labelName + '/updateNoValue/' + valueState, null, requestDefaultConfig);
};

export const deleteLabel = (projectName, labelCollectionIdentifier, labelName) => {
	return axios.delete(settings.getApi() + 'projects/' + projectName + '/labelCollections/' + labelCollectionIdentifier + '/labels/' + labelName, requestDefaultConfig);
};

// TRANSLATION
export const fetchTranslations = (projectName, labelCollectionIdentifier, labelName, languageIdentifier, pluralKey) => {
	return axios.get(settings.getApi()
		+ 'projects/' + projectName
		+ '/labelCollections/' + labelCollectionIdentifier
		+ '/labels/' + labelName
		+ '/translations/' + languageIdentifier
		+ '/' + pluralKey,
	);
};

export const updateTranslation = (projectName, labelCollectionIdentifier, labelName, languageIdentifier, pluralKey, translation) => {
	return axios.post(settings.getApi()
		+ 'projects/' + projectName
		+ '/labelCollections/' + labelCollectionIdentifier
		+ '/labels/' + labelName
		+ '/translations/' + languageIdentifier
		+ '/' + pluralKey,
		{data: translation}, requestDefaultConfig);
};

// IMPORT

export const uploadTranslationFile = (file) => {
	let formData = new FormData();
	formData.append('importFile', file);

	return axios.post(
		settings.getApi() + 'projects/import/uploadtranslationfile',
		formData,
		{
			...requestDefaultConfig,
			headers: {
				...requestDefaultConfig.headers,
				'Content-Type': 'multipart/form-data'
			}
		}
	);
};

// UTILITY
const requestDefaultConfig = {
	headers: {
		'X-Flow-Csrftoken': settings.getCsrfToken()
	},
	withCredentials: true
};


export const handleFetch = (getPromise, dispatch, callback, errorMessage) => {
	dispatch(system.startLoading());
	return getPromise()
		.then(
			response => {
				if (response.data.messages) {
					response.data.messages.forEach(message => dispatch(system.addMessage(new Message(
						message.type,
						message.code,
						message.message
					))));
				}
				if(response.data.success) {
					if (!_.isEmpty(response.data.data)) {
						callback(response.data.data);
					} else {
						callback([]);
						dispatch(system.addMessage(
							new Message(
								Message.TYPE_WARNING,
								404,
								errorMessage
							)
						))
					}
				}
			},
			error => {
				dispatch(system.addMessage(new Message(
					Message.TYPE_ERROR,
					error.code,
					error.message
				)));
			}
		)
		.finally(
			() => dispatch(system.endLoading())
		);
};

export const handleUpdate = (getPromise, dispatch, callback) => {
	dispatch(system.startLoading());
	return getPromise()
		.then(
			response => {
				if (response.data.success && callback) {
					callback();
				}
				if (response.data.messages) {
					response.data.messages.forEach(message => dispatch(system.addMessage(new Message(
						message.type,
						message.code,
						message.message
					))));
				}
				return response.data.success;
			},
			error => {
				dispatch(system.addMessage(new Message(
					Message.TYPE_ERROR,
					error.code,
					error.message
				)));
				return false;
			},
		)
		.finally(
			() => dispatch(system.endLoading())
		);
};



// WEBPACK FOOTER //
// ./React/src/services/api.js